import styled from 'styled-components';

import colors from '@/design/colors';
import { HeadingLarge, HeadingSmall } from '@/design/typography';

import { InputContent } from '@/components/InputField/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const Heading = styled.h2`
  display: flex;
  align-items: center;
  column-gap: 20px;
  margin-top: 32px;

  svg {
    width: 20px;
    height: 20px;
  }

  ${HeadingLarge(16)};
  color: ${colors.blackAlpha200};
`;

export const OPMEBox = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  border-radius: 10px;
  border: 1.5px solid ${colors.gray100};
  overflow: hidden;
`;

export const OPMEBoxFeedback = styled.div`
  padding: 16px;
  background-color: ${colors.white};
`;

export const OPMEBoxContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  row-gap: 12px;
  background-color: ${colors.gray50};
`;

export const LoadingContent = styled.div`
  min-height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 10px;
`;

export const LoadingText = styled.span`
  ${HeadingSmall(14)};
  color: ${colors.blackAlpha200};
`;

export const OPMEGroup = styled.table`
  width: 100%;

  border-spacing: 8px;

  thead {
    ${HeadingSmall(14)};
    color: ${colors.blackAlpha200};

    td:first-child {
      width: 100%;
    }
  }

  tbody {
    td:first-child {
      ${InputContent} {
        width: 100%;
      }
    }
  }
`;

export const OPMEGroupTitle = styled.div``;
